/* eslint-disable no-undef */
import React, { useState } from 'react';
import { ContainerFormForStatusFooter, ContainerMenu } from '../../../../components/Containers';
import HeaderTitle from '../../../../components/HeaderTitle';
import LineTableMonth from '../../../../components/NovoSistema/LineTableMonth';
import LineTableYear from '../../../../components/NovoSistema/LineTableYear';
import TableMonth from '../../../../components/NovoSistema/TableMonth';
import TableYear from '../../../../components/NovoSistema/TableYear';
import WrapperButtonsLinks from '../../../../components/NovoSistema/WrapperButtonsLinks';

export default function TemplateObrigacoesAcessoriasFiscal() {
  const [year, setYear] = useState('21');
  return (
    <ContainerMenu>
      <ContainerFormForStatusFooter>
        <HeaderTitle text="Obrigações Acessórias Fiscais" linkIcon="/images/icons/information.svg" />
        <WrapperButtonsLinks year={year} setYear={setYear} />
        <TableMonth>
          <LineTableMonth
            title="DES – Declaração Eletrônica de Serviços"
            firstLetter="D"
            secondLetter="R"
            firstLinkJan="#"
            secondLinkJan="#"
            firstLinkFev="#"
            secondLinkFev="#"
            firstLinkMar="#"
            secondLinkMar="#"
            firstLinkAbr="#"
            secondLinkAbr="#"
            firstLinkMai="#"
            secondLinkMai="#"
            firstLinkJun="#"
            secondLinkJun="#"
            firstLinkJul="#"
            secondLinkJul="#"
            firstLinkAgo="#"
            secondLinkAgo="#"
            firstLinkSet="#"
            secondLinkSet="#"
            firstLinkOut="#"
            secondLinkOut="#"
            firstLinkNov="#"
            secondLinkNov="#"
            firstLinkDez="#"
            secondLinkDez="#"
          />
          <LineTableMonth
            title="GIA – Guia de Informação e Apuração do ICMS"
            firstLetter="D"
            secondLetter="R"
            firstLinkJan="#"
            secondLinkJan="#"
            firstLinkFev="#"
            secondLinkFev="#"
            firstLinkMar="#"
            secondLinkMar="#"
            firstLinkAbr="#"
            secondLinkAbr="#"
            firstLinkMai="#"
            secondLinkMai="#"
            firstLinkJun="#"
            secondLinkJun="#"
            firstLinkJul="#"
            secondLinkJul="#"
            firstLinkAgo="#"
            secondLinkAgo="#"
            firstLinkSet="#"
            secondLinkSet="#"
            firstLinkOut="#"
            secondLinkOut="#"
            firstLinkNov="#"
            secondLinkNov="#"
            firstLinkDez="#"
            secondLinkDez="#"
          />
          <LineTableMonth
            title="SINTEGRA – Sistema Integrado Inform. s/ Oper. Interestaduais c/ Mercad. e Serv."
            firstLetter="D"
            secondLetter="R"
            firstLinkJan="#"
            secondLinkJan="#"
            firstLinkFev="#"
            secondLinkFev="#"
            firstLinkMar="#"
            secondLinkMar="#"
            firstLinkAbr="#"
            secondLinkAbr="#"
            firstLinkMai="#"
            secondLinkMai="#"
            firstLinkJun="#"
            secondLinkJun="#"
            firstLinkJul="#"
            secondLinkJul="#"
            firstLinkAgo="#"
            secondLinkAgo="#"
            firstLinkSet="#"
            secondLinkSet="#"
            firstLinkOut="#"
            secondLinkOut="#"
            firstLinkNov="#"
            secondLinkNov="#"
            firstLinkDez="#"
            secondLinkDez="#"
          />
          <LineTableMonth
            title="EFD ISS - Escrituração Fiscal Digital Municipal – Bloco B"
            firstLetter="D"
            secondLetter="R"
            firstLinkJan="#"
            secondLinkJan="#"
            firstLinkFev="#"
            secondLinkFev="#"
            firstLinkMar="#"
            secondLinkMar="#"
            firstLinkAbr="#"
            secondLinkAbr="#"
            firstLinkMai="#"
            secondLinkMai="#"
            firstLinkJun="#"
            secondLinkJun="#"
            firstLinkJul="#"
            secondLinkJul="#"
            firstLinkAgo="#"
            secondLinkAgo="#"
            firstLinkSet="#"
            secondLinkSet="#"
            firstLinkOut="#"
            secondLinkOut="#"
            firstLinkNov="#"
            secondLinkNov="#"
            firstLinkDez="#"
            secondLinkDez="#"
          />
          <LineTableMonth
            title="SPED EFD ICMS/IPI Mercadorias– Escrituração Fiscal Digital – Bloco C"
            firstLetter="D"
            secondLetter="R"
            firstLinkJan="#"
            secondLinkJan="#"
            firstLinkFev="#"
            secondLinkFev="#"
            firstLinkMar="#"
            secondLinkMar="#"
            firstLinkAbr="#"
            secondLinkAbr="#"
            firstLinkMai="#"
            secondLinkMai="#"
            firstLinkJun="#"
            secondLinkJun="#"
            firstLinkJul="#"
            secondLinkJul="#"
            firstLinkAgo="#"
            secondLinkAgo="#"
            firstLinkSet="#"
            secondLinkSet="#"
            firstLinkOut="#"
            secondLinkOut="#"
            firstLinkNov="#"
            secondLinkNov="#"
            firstLinkDez="#"
            secondLinkDez="#"
          />
          <LineTableMonth
            title="SPED EFD PIS/COFINS/CPRB - Escrituração Fiscal Digital Contribuições"
            firstLetter="D"
            secondLetter="R"
            firstLinkJan="#"
            secondLinkJan="#"
            firstLinkFev="#"
            secondLinkFev="#"
            firstLinkMar="#"
            secondLinkMar="#"
            firstLinkAbr="#"
            secondLinkAbr="#"
            firstLinkMai="#"
            secondLinkMai="#"
            firstLinkJun="#"
            secondLinkJun="#"
            firstLinkJul="#"
            secondLinkJul="#"
            firstLinkAgo="#"
            secondLinkAgo="#"
            firstLinkSet="#"
            secondLinkSet="#"
            firstLinkOut="#"
            secondLinkOut="#"
            firstLinkNov="#"
            secondLinkNov="#"
            firstLinkDez="#"
            secondLinkDez="#"
          />
          <LineTableMonth
            title="DCTF – Declaração de Débitos Tributários Federais"
            firstLetter="D"
            secondLetter="R"
            firstLinkJan="#"
            secondLinkJan="#"
            firstLinkFev="#"
            secondLinkFev="#"
            firstLinkMar="#"
            secondLinkMar="#"
            firstLinkAbr="#"
            secondLinkAbr="#"
            firstLinkMai="#"
            secondLinkMai="#"
            firstLinkJun="#"
            secondLinkJun="#"
            firstLinkJul="#"
            secondLinkJul="#"
            firstLinkAgo="#"
            secondLinkAgo="#"
            firstLinkSet="#"
            secondLinkSet="#"
            firstLinkOut="#"
            secondLinkOut="#"
            firstLinkNov="#"
            secondLinkNov="#"
            firstLinkDez="#"
            secondLinkDez="#"
          />
        </TableMonth>
        <TableYear year={year}>
          <LineTableYear
            title="SPED EFD ICMS Serviço – Escrituração Fiscal Digital – Bloco D"
            firstLink="#"
            secondLink="#"
          />
          <LineTableYear
            title="SPED EFD ICMS CIAP - Controle do Crédito de ICMS Ativo Permanente – Bloco G"
            firstLink="#"
            secondLink="#"
          />
          <LineTableYear title="SPED EFD – Inventário Físico – Bloco H" firstLink="#" secondLink="#" />
          <LineTableYear title="SPED EFD - Controle da Produção e do Estoque – Bloco K" firstLink="#" secondLink="#" />
          <LineTableYear
            title="SPED EFD IRPJ/CSLL - Escrituração Fiscal Digital sobre a Renda"
            firstLink="#"
            secondLink="#"
          />
          <LineTableYear
            title="DIRF – Declaração do Imposto sobre a Renda Retido na Fonte"
            firstLink="#"
            secondLink="#"
          />
        </TableYear>
      </ContainerFormForStatusFooter>
    </ContainerMenu>
  );
}
